

<ng-container *ngIf="hasAcceptedTerms">
  <div  class="mainContent">
    <router-outlet></router-outlet>
    <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
    
  </div>
  <!-- <app-footer ></app-footer> -->
</ng-container>

<div *ngIf="!hasAcceptedTerms" class="mainContent">
  <app-terms-acceptor ></app-terms-acceptor>
</div>

